import { BASE_URL, OFFICE_SOCKET } from "@/env";
import { io } from "socket.io-client";
let socket =
  !OFFICE_SOCKET
    ? null
    : io(`${BASE_URL}`, {
        //auth: {
        //  token: currentToken,
        //},
        transports: ["websocket"], // Evita "polling" y usa solo WebSockets
        reconnection: true, // Habilita reconexión automática
        reconnectionAttempts: 5, // Máximo 5 intentos
        reconnectionDelay: 3000, // Espera 3 segundos entre intentos
      });

export const SocketOffice = socket;
